import './utils/prototypes'
import { createRoot } from 'react-dom/client'
import 'styles/themes.css'
import 'styles/tailwind.css'
import 'styles/customChartTooltip.css'
import 'styles/animations.scss'
import App from './App'

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(<App />)
